import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import { useNavigate } from "react-router-dom";

const AddressUpdateReport = () => {
  const [addressData, setAddressData] = useState([]);
  const tableRef = useRef(null);
  const navigate = useNavigate();

  // 🔹 Fetch retailer address update records
  useEffect(() => {
    const fetchAddressData = async () => {
      try {
        const authToken = localStorage.getItem("authToken");

        const response = await fetch(`${API_BASE_URL}/AddressUpdate/GetAddressUpdateRecords`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${authToken}`,
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        let data = await response.json();

        // 🔹 Only IN PROGRESS records for retailer
        data = data
          .filter(r => r.status === "In Progress")
          .map((record, index) => ({
            ...record,
            SrNo: index + 1
          }));

        setAddressData(data);
      } catch (error) {
        console.error('Failed to fetch address update records:', error);
      }
    };

    fetchAddressData();
  }, []);

  // 🔹 Init DataTable
  useEffect(() => {
    if (tableRef.current && addressData.length > 0) {
      const table = $(tableRef.current).DataTable({
        destroy: true,
        data: addressData,
        columns: [
          { data: 'SrNo', title: 'Sr No' },
          { data: 'startDate', title: 'Date' },
          { data: 'registrationNo', title: 'Registration No' },
          { data: 'registerMobNo', title: 'Mobile No' },
          { data: 'aadhaarNumber', title: 'Aadhaar No' },
          { data: 'address', title: 'Address' },
          { data: 'pinCode', title: 'Pin Code' },
          { data: 'state', title: 'State' },
          { data: 'district', title: 'District' },
          { data: 'postOffice', title: 'Post Office' },
          {
            data: 'status',
            title: 'Status',
            render: function (data) {
              return `<span class="badge badge-info">${data}</span>`;
            }
          },
          { data: 'comment', title: 'Comment' },
          {
            data: null,
            title: "Document",
            render: function (data, type, row) {
              return `<button class="btn btn-sm btn-success download-doc-btn" data-id="${row.registrationNo}">
                        Download
                      </button>`;
            }
          },
          {
            data: null,
            title: "Edit",
            render: function (data, type, row) {
              return `<button class="btn btn-sm btn-primary edit-btn" data-id="${row.id}">
                        Edit
                      </button>`;
            }
          }
        ]
      });

      // 🔹 Download document
      $('#productsTable tbody')
        .off('click', '.download-doc-btn')
        .on('click', '.download-doc-btn', function () {
          const registrationNo = $(this).data("id");
          downloadDocument(registrationNo);
        });

      $('#productsTable tbody')
        .off('click', '.edit-btn')
        .on('click', '.edit-btn', function () {
          const id = $(this).data("id");
          localStorage.setItem("addressUpdateId", id);
          navigate("/dashboard/address-update");
        });

      return () => {
        table.destroy();
      };
    }
  }, [addressData]);

  // 🔹 Download uploaded document
  const downloadDocument = async (registrationNo) => {
    try {
      const authToken = localStorage.getItem("authToken");

      const response = await fetch(`${API_BASE_URL}/AddressUpdate/DownloadDocument/${registrationNo}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (!response.ok) {
        alert("Document not available");
        return;
      }

      const blob = await response.blob();
      const contentType = response.headers.get("Content-Type");
      const extension = contentType?.split("/")[1] || "file";

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `AddressUpdate_${registrationNo}.${extension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <table
      ref={tableRef}
      id="productsTable"
      className="table table-bordered table-hover table-product"
      style={{ width: '100%' }}
    >
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Date</th>
          <th>Registration No</th>
          <th>Mobile No</th>
          <th>Aadhaar No</th>
          <th>Address</th>
          <th>Pin Code</th>
          <th>State</th>
          <th>District</th>
          <th>Post Office</th>
          <th>Status</th>
          <th>Comment</th>
          <th>Document</th>
          <th>Edit</th>
        </tr>
      </thead>
    </table>
  );
};

export default AddressUpdateReport;


// import React, { useEffect, useRef, useState } from 'react';
// import $ from 'jquery';
// import 'datatables.net-bs4';
// import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const AddressUpdateReport = () => {
//     const [addressData, setAddressData] = useState([]);
//     const tableRef = useRef(null);

//     useEffect(() => {
//         const fetchAddressData = async () => {
//             try {
//                 const authToken = localStorage.getItem("authToken");

//                 const response = await fetch('https://apiv2.chakran.in/api/AddressUpdate/GetAddressRecords', {
//                     method: 'GET',
//                     headers: {
//                         Authorization: `Bearer ${authToken}`,
//                     }
//                 });

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! Status: ${response.status}`);
//                 }

//                 let data = await response.json();

//                 // Add SrNo and filter for In Progress if needed
//                 // For now, showing all records as per the "no popup/edit" requirement
//                 data = data.map((record, index) => ({
//                     ...record,
//                     SrNo: index + 1
//                 }));

//                 setAddressData(data);
//             } catch (error) {
//                 console.error('Failed to fetch address update records:', error);
//             }
//         };

//         fetchAddressData();
//     }, []);

//     useEffect(() => {
//         if (tableRef.current && addressData.length > 0) {
//             const table = $(tableRef.current).DataTable({
//                 destroy: true,
//                 data: addressData,
//                 columns: [
//                     { data: 'SrNo', title: 'Sr No' },
//                     { data: 'startDate', title: 'Date' },
//                     { data: 'registrationNo', title: 'Registration No' },
//                     { data: 'registerMobNo', title: 'Mobile No' },
//                     { data: 'aadhaarNumber', title: 'Aadhaar No' },
//                     { data: 'pinCode', title: 'Pin Code' },
//                     { data: 'state', title: 'State' },
//                     { data: 'district', title: 'District' },
//                     { data: 'postOffice', title: 'Post Office' },
//                     {
//                         data: 'status',
//                         title: 'Status',
//                         render: function (data) {
//                             return `<span class="badge badge-info">${data || 'Submitted'}</span>`;
//                         }
//                     },
//                     { data: 'comment', title: 'Comment' },
//                     {
//                         data: null,
//                         title: "Action",
//                         render: function (data, type, row) {
//                             return `<button class='btn btn-sm btn-primary download-btn' data-id='${row.registrationNo}'>Download PDF</button>`;
//                         },
//                     },
//                     {
//                         data: null,
//                         title: "Document",
//                         render: function (data, type, row) {
//                             return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}'>Download</button>`;
//                         },
//                     }
//                 ]
//             });

//             $('#productsTable tbody').off('click', '.download-btn').on('click', '.download-btn', function () {
//                 const registrationNo = $(this).data("id");
//                 downloadPDF(registrationNo, "form");
//             });

//             $('#productsTable tbody').off('click', '.download-doc-btn').on('click', '.download-doc-btn', function () {
//                 const registrationNo = $(this).data("id");
//                 downloadPDF(registrationNo, "document");
//             });

//             return () => {
//                 table.destroy();
//             };
//         }
//     }, [addressData]);

//     const downloadPDF = async (registrationNo, type) => {
//         try {
//             const authToken = localStorage.getItem("authToken");

//             const endpoint = type === "form"
//                 ? `https://apiv2.chakran.in/api/AddressUpdate/DownloadPdf/${registrationNo}`
//                 : `https://apiv2.chakran.in/api/AddressUpdate/DownloadDocument/${registrationNo}`;

//             const response = await fetch(endpoint, {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${authToken}`,
//                 },
//             });

//             if (!response.ok) {
//                 throw new Error(`Failed to download file: ${response.status}`);
//             }

//             const blob = await response.blob();
//             const contentType = response.headers.get("Content-Type");
//             const fileExtension = contentType.split("/")[1] || "pdf";

//             const url = window.URL.createObjectURL(blob);
//             const a = document.createElement("a");
//             a.href = url;
//             a.download = `AddressUpdate_${type}_${registrationNo}.${fileExtension}`;
//             document.body.appendChild(a);
//             a.click();
//             document.body.removeChild(a);
//         } catch (error) {
//             console.error("Download error:", error);
//         }
//     };

//     return (
//         <table
//             ref={tableRef}
//             id="productsTable"
//             className="table table-bordered table-hover table-product"
//             style={{ width: '100%' }}
//         >
//             <thead>
//                 <tr>
//                     <th>Sr. No.</th>
//                     <th>Date</th>
//                     <th>Registration No</th>
//                     <th>Mobile No</th>
//                     <th>Aadhaar No</th>
//                     <th>Pin Code</th>
//                     <th>State</th>
//                     <th>District</th>
//                     <th>Post Office</th>
//                     <th>Status</th>
//                     <th>Comment</th>
//                     <th>Action</th>
//                     <th>Document</th>
//                 </tr>
//             </thead>
//         </table>
//     );
// };

// export default AddressUpdateReport;
